import { render, staticRenderFns } from "./ContentBanner.vue?vue&type=template&id=2a601d72&"
import script from "./ContentBanner.vue?vue&type=script&lang=js&"
export * from "./ContentBanner.vue?vue&type=script&lang=js&"
import style0 from "./ContentBanner.vue?vue&type=style&index=0&id=2a601d72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports